import {
	resolveEventId,
	resolveOccurrenceId,
	resolveSourceName,
} from "src/utils/trackingNormalizer";
import Queue from "./Queue";

export default class EventViewTracker {
	constructor() {
		this.queue = new Queue();
	}

	getPendingViews() {
		return this.queue.flush();
	}

	addViewToQueue(event, viewedFrom) {
		this.queue.add(this.createEventViewContext(event, viewedFrom));
	}

	createEventViewContext(event, viewedFrom) {
		return {
			schema: "iglu:com.evvnt/event_view/jsonschema/2-0-0",
			data: {
				viewedFrom: viewedFrom,
				source: resolveSourceName(event),
				sourceOccurrenceId: resolveOccurrenceId(event),
				sourceEventId: resolveEventId(event),
			},
		};
	}
}
